import { Autocomplete as MuiAutocomplete, AutocompleteProps } from '@mui/material';

export const Autocomplete = MuiAutocomplete;
export type { AutocompleteProps };
